module.exports = __webpack_public_path__ + "img/portomarina.2f3e6a37.jpg";